import { useMemo } from 'react';
import { REPORT_DATA_SOURCE, SelectItem, WIDGET_TYPE } from '../../../../../../../types';
import { useBreakdownData } from '../../../../../hooks/useBreakdownData';
import { FormField } from '../../../../../../../components/FormField/FormField';
import { SingleSelect } from '../../../../../../../components/SingleSelect/SingleSelect';
import { ChipsSelectorV2 } from '../../../../../../../components/ButtonSelector/ChipsSelectorV2';
import { EXCLUSION_ANSWER_OPTIONS } from '../../constants';

interface Props {
  selectedQuestion?: SelectItem | null;
  setSelectedQuestion: (question: SelectItem | null) => void;
  widgetTypeOptions: SelectItem[];
  selectedType?: SelectItem | null;
  setSelectedType: (type: SelectItem | null) => void;
  selectedAnswer?: SelectItem | null;
  setSelectedAnswer: (answer: SelectItem | null) => void;
}

export const ExclusionsTypeContent = ({
  setSelectedQuestion,
  selectedQuestion,
  widgetTypeOptions,
  selectedType,
  setSelectedType,
  selectedAnswer,
  setSelectedAnswer,
}: Props) => {
  const { selectedColumns } = useBreakdownData();

  const questionOptions: SelectItem[] = useMemo(() => {
    return selectedColumns
      ?.filter((q) => q.sourceType === REPORT_DATA_SOURCE.EXCLUSIONS)
      ?.map((q) => {
        if (!q) return null;
        return { id: q?.id, value: q?.name };
      })
      ?.filter((q) => Boolean(q)) as SelectItem[];
  }, [selectedColumns]);

  const answerOptions: SelectItem[] = useMemo(() => {
    return EXCLUSION_ANSWER_OPTIONS;
  }, []);
  return (
    <>
      <FormField label={'Exclusions'}>
        <SingleSelect
          style={{ width: '100%' }}
          options={questionOptions}
          value={selectedQuestion}
          onChange={(_, questionOption) => setSelectedQuestion(questionOption)}
          disablePortal
          fieldPlaceholder={'Select Exclusion'}
        />
      </FormField>
      <FormField label={'Widget Type'}>
        <ChipsSelectorV2
          options={widgetTypeOptions}
          selectedItem={selectedType || null}
          onSelect={(type) => setSelectedType(type)}
        />
      </FormField>
      {selectedType?.id === WIDGET_TYPE.COMPANY_BREAKDOWN && selectedQuestion && (
        <FormField label={'Checkup Conclusions'}>
          <SingleSelect
            style={{ width: '100%' }}
            options={answerOptions}
            value={selectedAnswer}
            onChange={(_, answer) => setSelectedAnswer(answer)}
            disablePortal
            fieldPlaceholder={'Select Checkup Conclusions'}
          />
        </FormField>
      )}
    </>
  );
};
